export default () => ({
  email: '',
  password: '',
  keepLogged: false
});
